import { duration, TimeValue, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

/**
 * Time component that displays in HH:MM:SS format
 * the current time or time since the [since] attribute.
 */
var TimeComponent = /** @class */ (function (_super) {
    __extends(TimeComponent, _super);
    function TimeComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.time = _this.getHMS();
        return _this;
    }
    TimeComponent.prototype.created = function () {
        var _this = this;
        this.timer = setInterval(function () {
            _this.time = _this.getHMS();
        }, 1000);
    };
    TimeComponent.prototype.destroyed = function () {
        if (this.timer) {
            clearInterval(this.timer);
        }
    };
    Object.defineProperty(TimeComponent.prototype, "outputTime", {
        get: function () {
            var _a = this.time, hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            var output = [hours, minutes];
            if (this.withSeconds) {
                output.push(seconds);
            }
            return output.map(this.pad).join(':');
        },
        enumerable: false,
        configurable: true
    });
    TimeComponent.prototype.pad = function (n) {
        return ("" + n).padStart(2, '0');
    };
    TimeComponent.prototype.getHMS = function () {
        var _a = duration(this.getTimestamp()), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
        return { hours: hours, minutes: minutes, seconds: seconds };
    };
    TimeComponent.prototype.getTimestamp = function () {
        if (!this.since) {
            var date = new Date();
            return date.getTime() - date.getTimezoneOffset() * TimeValue.MINUTE;
        }
        var timestamp = Date.now() - this.since;
        return timestamp < 0 ? 0 : timestamp;
    };
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], TimeComponent.prototype, "since", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        }),
        __metadata("design:type", Boolean)
    ], TimeComponent.prototype, "withSeconds", void 0);
    TimeComponent = __decorate([
        Component({
            name: 'ui-time',
            inheritAttrs: false,
        })
    ], TimeComponent);
    return TimeComponent;
}(Mixins(MagicConfigMixin)));

export default TimeComponent;
